import { Col, Row, Table } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PrecariteInfo = () => {
  const { t } = useTranslation();
  const precaireDataSource = [
    {
      key: '1',
      personnes: '1',
      revenus: '0 à 24 031 €',
    },
    {
      key: '2',
      personnes: '2',
      revenus: '24 031 à 35 270 €',
    },
    {
      key: '3',
      personnes: '3',
      revenus: '35 270 à 42 357 €',
    },
    {
      key: '4',
      personnes: '4',
      revenus: '42 357 à 49 455 €',
    },
    {
      key: '5',
      personnes: '5',
      revenus: '49 455 à 56 580 €',
    },
    {
      key: '6',
      personnes: t('precarite_info:personne_supplementaire'),
      revenus: '+ 7 116 €',
    },
  ];

  const modesteDataSource = [
    {
      key: '1',
      personnes: '1',
      revenus: '24 031 à 29 253 €',
    },
    {
      key: '2',
      personnes: '2',
      revenus: '35 270 à 42 933 €',
    },
    {
      key: '3',
      personnes: '3',
      revenus: '42 357 à 51 564 €',
    },
    {
      key: '4',
      personnes: '4',
      revenus: '49 455 à 60 208 €',
    },
    {
      key: '5',
      personnes: '5',
      revenus: '56 580 à 68 877 €',
    },
    {
      key: '6',
      personnes: t('precarite_info:personne_supplementaire'),
      revenus: '+ 8 663 €',
    },
  ];

  const columns = [
    {
      title: t('precarite_info:title_personnes'),
      dataIndex: 'personnes',
      key: 'personnes',
      minWidth: 150,
    },
    {
      title: t('precarite_info:title_revenus'),
      dataIndex: 'revenus',
      key: 'revenus',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} lg={12}>
        <p
          className={
            'text-base mt-4 py-2 bg-dark-gray-100 rounded-t-xl pl-2 !font-normal'
          }
        >
          {t('precarite_info:precaire')}
        </p>
        <Table
          dataSource={precaireDataSource}
          columns={columns}
          pagination={false}
          size={'small'}
          bordered
        />
      </Col>
      <Col xs={24} lg={12}>
        <p
          className={
            'text-base mt-4 py-2 bg-dark-gray-100 rounded-t-xl pl-2 !font-normal'
          }
        >
          {t('precarite_info:modeste')}
        </p>
        <Table
          dataSource={modesteDataSource}
          columns={columns}
          pagination={false}
          size={'small'}
          bordered
        />
      </Col>
    </Row>
  );
};

export default PrecariteInfo;
